export default {
  Home: '首页',
  WhoAreWe: 'Who Are We',
  WhatWeDo: '产品专区',
  Solutions: 'Solutions',
  Construction: 'Construction',
  Retail: 'Retail',
  HealthCare: 'Health Care',
  EventVenues: 'Event Venues',
  Transportation: 'Transportation',
  Hospitality: 'Hospitality',
  Platforms: 'Platforms',
  OurClient: 'Our Client',
  HowItWorks: 'How it works',
  IMDF: 'IMDF',
  Contacts: '关于我们',
  SmartVenues: 'Smart Venues',
  SmartConstruction: 'Smart Construction',
  OurTeam: '关于我们',

  // home
  'home-head-h1': '探索未知之境',
  'home-head-small': '运动无限，把整个城市当做一个大运动场，探索更多未知的可能',
  'section-title-1': '健康运动',
  'section-sub-title-1': '每一步，与你同行；每一个脚印，都是对自己的肯定',
  'section-1-img-1-title': '健康运动计步器APP',
  'section-1-img-1-p': '精准计步，个性化定制运动目标，让运动更自律；预知天气，提前制定出行计划；健康音乐，帮助您更投入学习，提升睡眠质量',
  'section-1-img-2-title': '乐步APP',
  'section-1-img-2-p': '精准计步，统计并曲线展示历史运动记录；畅玩各种路线，让运动更有趣；统计运功排行，让运动更有动力',
  'section-sub-title-2': '下载',
  'section-2-img-1-title': '扫描二维码下载',
  'section-2-img-1-p': '健康运动计步器Android版',
  'section-2-img-2-title': '扫描二维码下载',
  'section-2-img-2-p': '乐步Android版',
  'section-2-img-3-title': '扫描二维码下载',
  'section-2-img-3-p': '乐步IOS版',
  'section-1-img-3-title': '展館端解決方案',
  'section-1-img-3-p': '展品介紹服務，館內導引服務並能結合展品介紹服務，依據參觀者位置主動動態介紹展品服務。',
  'section-title-2': '我們的優勢',
  'section-2-row-1-title': '場域定位技術',
  'section-2-row-1-detail': 'UWD室內精準定位系統：<br/>10cm~30cm高精密度定位距離，快速迅速定位。支援無限制擴充裝置數量。適用於長期建置，高穩定性。',
  'section-2-row-2-title': '裝置定位技術',
  'section-2-row-2-detail': '裝置定位方式採用兩種方式：<br/>手機定位結合專屬APP，適用於大型公共場域用戶。藍芽手環裝置定位，適用於工廠或醫院用戶',
  'section-2-row-3-title': '客製化功能系統',
  'section-2-row-3-detail': '配合場域需求搭配人員定位系統，客製功能需求。搭配旅客登機提醒功能，孩童距離提醒功能。人員呼救與周邊商家推廣...等等功能。',

  // solutions
  'solutions-head-h1': 'Comprehensive <br/> multimedia solution',
  'solutions-head-small': 'From large TV walls to KIOSK multi-touch screens and the latest wave of somatosensory devices, according to different commercial marketing stages, we have developed corresponding application technologies to help customers create new-style business operation models and enhance brand market visibility, and Increase corporate profits and brand value.',
  'solutions-content-title': 'Through comprehensive multimedia interaction Solutions become a communication platform between brands and consumers',
  'solutions-item-1-title': 'Construction',
  'solutions-item-1-detail': 'Interactive maps and wayfinding for smart office',
  'solutions-item-2-title': 'RETAIL',
  'solutions-item-2-detail': 'Maps and wayfinding for shopping centers and retailers',
  'solutions-item-3-title': 'HEALTHCARE',
  'solutions-item-3-detail': 'Interactive maps and wayfinding for hospitals',
  'solutions-item-4-title': 'EVENT VENUES',
  'solutions-item-4-detail': 'Event maps and wayfinding for trade shows, conventions and festivals.',
  'solutions-item-5-title': 'TRANSPORTATION',
  'solutions-item-5-detail': 'Indoor maps and wayfinding for airports and train stations',
  'solutions-item-6-title': 'HOSPITALITY',
  'solutions-item-6-detail': 'Maps and wayfinding solution for hotels, cruise lines and theme parks.',

  // platforms
  'platforms-head-h1': 'Deploy new digital <br />services inside your <br />smart buildings',
  'platforms-head-small': 'A simple hit on the “Publish” button will allow you to share your map with everyone!',
  'platforms-item-1-title': 'Wayfinding',
  'platforms-item-1-detail': 'Mapwize has a Search Engine that allows users to locate any kind of resources on the map whether it is a meeting room or a printer.' +
    '<br /><br />' +
    'Mapwize provides a powerful Direction Engine to compute the best route towards your destination and can also optimize multi-destination itineraries. Reduced mobility users can select a dedicated mode to obtain suitable itineraries.',
  'platforms-item-2-title': 'CMS',
  'platforms-item-2-detail': `Mapwize uses outdoor global maps and adds indoor data to them. This way, our maps combine both indoor and outdoor services using the same tool.
    <br/><br/>
    All data not being of interest for everyone, Mapwize offers different Universes to display appropriate content in accordance with user roles (visitors, occupants, maintenance workers, security agents, etc.). Mapwize can manage an unlimited number of Universes per venue.
    <br/><br/>
    Mapwize has always been a multilingual platform with the ability to handle any language including Non-Europeans (Russian, Chinese, Arabic, etc.).`,
  'platforms-item-3-title': 'Dashboard',
  'platforms-item-3-detail': `Mapwize’s back-office, the Studio, is able to process the most common building file formats such as Autocad or GeoJSon. This way the overall floorplan import process is rapidly executed even by non-specialists.
    <br/><br/>
    Once existing floorplans are imported, the Studio provides all the necessary tools to add data and customize the maps. This includes but is not limited to: Universes, Points-of-Interest, Directions, Languages. Changes and updates are propagated in real-time on the platform.`,
  'platforms-item-4-title': 'Framework',
  'platforms-item-4-detail': `Mapwize works with any Indoor Positioning System (IPS) including but not limited to: Beacons, Wi-Fi, Li-Fi, Ultrasounds, Earth’s Magnetic field, Sensor fusion. Additionally, Mapwize provides a unique framework designed to combine multiple IPSs and select the most accurate system at anytime. Also, this framework enables advanced filters to increase position accuracy based on building topology.
    <br/><br/>
    This framework, called Indoor Positioning is available as an Open Source project under the MIT License.`,
  'platforms-item-5-title': 'Automation',
  'platforms-item-5-detail': `Mapwize is an open platform by design because we believe Indoor Mapping should be a core component to many third-party software applications. Accordingly, we also believe it is of the most importance to give developers a highly customizable mapping component.
    <br/><br/>
    Therefore, Mapwize comes with a fully interoperable Application Programming Interface (API) to permit server-side automation and multiple SDKs for iOS, Android and Javascript. This way, developers can easily embed Mapwize maps inside their own applications.
    <br/><br/>
    Mapwize API and SDKs are freely available on Github.`,
  'platforms-item-6-title': 'Security',
  'platforms-item-6-detail': `Security is a top concern here at Mapwize. Our maps are protected by strong access keys which are both customizable in scope (universes, floors, etc.) and duration.
    <br/><br/>
    Mapwize is hosted on the Microsoft Azure Cloud and is either available in SaaS mode (Multi-tenant server or private server) or on-premises.`,

  // how it works
  'howitworks-head-h1': 'How our service works',
  'howitworks-head-small': 'A seamless path for buildings Indoor mapping just became easy. super easy to integrate and our customers would tell you the same! We are a developer-friendly company committed to providing the most complete tools for those who create the best mobile and web applications.',
  'howitworks-item-1-title': '整合服務',
  'howitworks-item-1-detail': '協助增建客戶需求功能。',
  'howitworks-item-2-title': '客製化可視化介面',
  'howitworks-item-2-detail': '客製化可視化介面，包含生產數據、機台運轉狀況、庫存資料呈現、客製化需求頁面。便利使用端快速了解生產資訊內容。',
  'howitworks-item-3-title': '數據收集',
  'howitworks-item-3-detail': '提供機台生產數據資料擷取功能。透過PLC資料擷取盒，獲取機台內部生產數據。解決無法取得機台生產資訊問題。',
  'howitworks-item-4-title': '依據機台數據進行分析',
  'howitworks-item-4-detail': '依據機台數據進行分析，透過AI自主學習技術進行問題建模，進而改善生產問題，提升生產效能。解決生產中問題狀況，有效提升生產效能與減少庫料耗損。',

  // imdf
  'imdf-head-h1': 'Apple Indoor <br/> Positioning Technology',
  'imdf-head-small': `Compathnion provides zero-additional hardware solution using Any WiFi based on Wherami technology. In iOS, we have cooperation with Apple ecosystem.
    <br/>
    Apple introduced indoor positioning technology for iOS on Any WiFi, which is accurate to about 3-5 metres. They have developed a new data model for positioning in iOS apps called IMDF.
    <br/>
    Compathnion is the 1st Large Scale Zero-Additional Hardware LBS Solution for both Android and iOS in the Greater Bay Area. And we have deployed the iOS solution in many venues.`,
  'imdf-item-1-title': 'How to enable iOS positioning?',
  'imdf-item-1-detail': `Compathnion has fruitful experience in implementation of the application with the iOS solutions. The steps needed to provide Apple Indoor Navigation is as follows:
    <br/><br/>
    <p>1. Register company account and venues in Apple Map Connect (https://register.apple.com/indoor)</p>
    <p>2. Create an IMDF and submit to Apple Map Connect</p>
    <p>3. Once approved, execute the site survey</p>
    <p>4. Submit the site survey data</p>
    <br/><br/>
    We provide a one-stop consultation and implementation service for IMDF creation, site survey, APP development, and maintenance.`,
  'section-2-title': 'Benefits of activating iOS Indoor Positioning',
  'imdf-horizontal-item-1-title': 'Native iOS support',
  'imdf-horizontal-item-1-content': `Seamless transition between indoor and outdoor positioning.<br/>
    Optimized battery consumption: the iOS Core Location service is optimized with iOS devices and minimizes the battery consumption during the positioning and navigation.`,
  'imdf-horizontal-item-2-title': 'A network effect',
  'imdf-horizontal-item-2-content': `As venue owner, once the iOS indoor positioning is activated in your venue, it can benefit for all apps developers working with the iOS platform.<br/>
    On the app side, the coverage indoor positioning will keep expanding once any venues enable indoor positioning on iOS.`,
  'imdf-horizontal-item-3-title': 'City-wide <br/> positioning service',
  'imdf-horizontal-item-3-content': 'iOS indoor positioning is designed to support city-wide apps. The service does not limit to a single venue, the indoor positioning service is optimized in a city-based level and even across cities.',

  // about
  'about-head-h1': 'About SagaDigits',
  'about-head-small': 'We are solely focused on providing the most complete mapping tools and indoor user experience.',
  'about-introduction-title': '介绍',
  'about-introduction-content': '我们是一家致力开发便民软件公司，人民需要什么我们就开发什么，高追求,高品质,爱创新，为人民服务，是我们的宗旨，我们相信不忘初心终有所得',
  'about-contact-title': '联系',
  'about-content-content': `商务合作
      <br />
      1768422205@@qq.com
      <br />
      业务咨询
      <br />
      020-62683334
      <br />
      广州市天河区科华街1号301至353室自编B181房`,

  // Construction
  'construction-title': 'Construction',
  'construction-detail': 'Customized visual interface, including production data, machine operating status, inventory data display and customized demand pages. Users can easily and quickly understand the content of production information.',
  'construction-item-1-title': '工業數位整合服務',
  'construction-item-1-detail': `
    工業4.0著重在將現有的工業相關的技術、銷售與產品體驗統合起來，是建立具有適應性、資源效率和人因工程學的智慧型工廠，我們將提供工廠數位化所需要的整合性技術服務。
    <br/><br/>
    MES：工廠生產履歷資訊建置協助服務
    <br/><br/>
    SCADA：環境監測與生產資訊可視化介面呈現應用服務
    <br/><br/>
    PLC：生產機台數據收集與自動化控制系統
    <br/><br/>
    AI深度學習技術：大數據深度分析與改善生產曲線服務系統。
  `,
  'construction-item-2-title': '整合服務架構',
  'construction-item-2-detail': `
    MES顧問管理，可視化建置服務，機台生產數據收集，AI深度學習技術
    <br/><br/>
    透過MES 系統架構，整合生產時所產生的數據資料，圖表化呈現顯示
    <br/><br/>
    透過我們的PLC資料擷取盒，主動獲取機台生產參數與數據資料，穩定傳送到MES資料庫中進行記錄。
    透過MES系統判斷彙整後，提供給予SCADA可視化介面進行數據資料呈現。
    <br/><br/>
    機台存取的數據資料，進入我們的AI深度學習技術，依據大數據分析後進而調整生產控制，有效提升生產效能。
  `,

  // Retail
  'retail-title': 'RETAIL',
  'retail-detail': 'Maps and wayfinding <br/> for shopping centers and retailers',
  'retail-section-1-title': 'Deliver a smart shopping experience <br/>with interactive maps',
  'retail-section-1-detail': `
    Where is what? How do I get to my favorite store? These are the questions visitors regularly ask themselves during their shopping experience.
    <br/><br/>
    Mapwize wayfinding is the foundation to start your digital in-store transformation. It offers new opportunities for the retail industry while improving the shopping experience.
    <br/><br/>
    More satisfied customers means more future visits, and more retailers looking to secure spaces in the mall. As a shopping center operator, you can equally benefit from satisfied visitors and store operators and thus increase your revenue.
  `,
  'retail-section-2-title': 'Benefits of digital maps <br/>for shopping centers',
  'retail-section-2-detail': 'Digital maps with wayfinding solutions is the first step to enhance the customer experience inside your shopping malls. A seamless and easy-to-update outdoor/indoor mapping system is an added value to help shoppers find their way around complex buildings and increase shop visibility.',
  'retail-section-2-list-item-1': 'Provide a smoother and extended shopping experience for visitors',
  'retail-section-2-list-item-2': 'Increase store visibility on all devices and at at all zoom levels',
  'retail-section-2-list-item-3': 'Improve space management and save costs',
  'retail-section-3-title': 'Benefits of digital maps for shopping centers',
  'retail-section-3-item-1-title': 'Wayfinding',
  'retail-section-3-item-1-detail': 'Enable visitors to navigate from the front door to their favorite stores. Display stores by categories, locate a specific store or a restaurant inside your shopping center.',
  'retail-section-3-item-2-title': 'Multiple Devices',
  'retail-section-3-item-2-detail': 'Enable visitors to navigate from the front door to their favorite stores. Display stores by categories, locate a specific store or a restaurant inside your shopping center.',
  'retail-section-3-item-3-title': 'Interactive Kiosk Maps',
  'retail-section-3-item-3-detail': 'Enable visitors to navigate from the front door to their favorite stores. Display stores by categories, locate a specific store or a restaurant inside your shopping center.',
  'retail-section-3-item-4-title': 'Store & Product Locator',
  'retail-section-3-item-4-detail': 'Help customers quickly locate products and stores they seek. Enable dynamic location updates thanks to our synchronization system linked to your database.',
  'retail-section-3-item-5-title': 'Personalized Maps',
  'retail-section-3-item-5-detail': 'Create multiple map views of your shopping mall and control access based on user profiles such as shoppers, maintenance teams and security agents.',
  'retail-section-3-item-6-title': 'Indoor Navigation',
  'retail-section-3-item-6-detail': 'Integrate your digital map into information kiosks, display the “you are here” on the map and let visitors follow the right directions on their smartphone.',

  // Health Care
  'health-care-title': 'HEALTHCARE',
  'health-care-detail': 'Interactive maps and wayfinding <br/> for hospitals',
  'health-care-section-1-title': 'Improve patients and staff <br /> experience with interactive maps',
  'health-care-section-1-detail': `
    According to many studies, 1 out of 2 hospital visitors has trouble finding their way around and 1 out of 4 staff members reports not being able to find their destination in their own hospital.
    <br/><br/>
    When someone is facing a new diagnosis or is worried about the health ofa loved one, the last thing they want to do is to wander throughmultiple buildings or to be late for a medical appointment.
    <br/><br/>
    Mapwize’s wayfinding technology provides a better patient and hospitalstaff experience through intuitive, stress-free navigation and reduces waittimes for hospital appointments.
  `,
  'health-care-section-2-title': 'Benefits of indoor wayfinding <br/> for hospitals',
  'health-care-section-2-detail': 'Our indoor mapping and wayfinding platform make it easy for patients and visitors to find their way through vast hospital grounds, reduce building complexity and enhance comfort. No more getting lost or interrupting medical staff for basic direction questions.',
  'health-care-section-2-list-item-1': 'Improve patients, guests and staff experience in your hospital',
  'health-care-section-2-list-item-2': 'Reduce number of late and missed appointments and save costs',
  'health-care-section-2-list-item-3': 'Optimize staff productivity with less interruptions of medical staff being asked for directions',
  'health-care-section-3-title': 'Provide smarter hospital wayfinding experiences',
  'health-care-section-3-item-1-title': 'Wayfinding',
  'health-care-section-3-item-1-detail': 'Enable visitors to navigate from the front door to their favorite stores. Display stores by categories, locate a specific store or a restaurant inside your shopping center.',
  'health-care-section-3-item-2-title': 'Multiple Devices',
  'health-care-section-3-item-2-detail': 'Enable visitors to navigate from the front door to their favorite stores. Display stores by categories, locate a specific store or a restaurant inside your shopping center.',
  'health-care-section-3-item-3-title': 'Interactive Kiosk Maps',
  'health-care-section-3-item-3-detail': 'Enable visitors to navigate from the front door to their favorite stores. Display stores by categories, locate a specific store or a restaurant inside your shopping center.',
  'health-care-section-3-item-4-title': 'Store & Product Locator',
  'health-care-section-3-item-4-detail': 'Help customers quickly locate products and stores they seek. Enable dynamic location updates thanks to our synchronization system linked to your database.',
  'health-care-section-3-item-5-title': 'Personalized Maps',
  'health-care-section-3-item-5-detail': 'Create multiple map views of your shopping mall and control access based on user profiles such as shoppers, maintenance teams and security agents.',
  'health-care-section-3-item-6-title': 'Indoor Navigation',
  'health-care-section-3-item-6-detail': 'Integrate your digital map into information kiosks, display the “you are here” on the map and let visitors follow the right directions on their smartphone.',
  'health-care-section-3-item-7-title': 'QR Code Locators',
  'health-care-section-3-item-7-detail': 'Allow people to locate themselves by scanning QR code stickers displayed across the healthcare facilities.',
  'health-care-section-3-item-8-title': 'Directions Sharing',
  'health-care-section-3-item-8-detail': 'Provide patients with appointment details and directions within the hospital in the text message or email reminder sent to them.',
  'health-care-section-3-item-9-title': 'Accessibility',
  'health-care-section-3-item-9-detail': 'Make your hospital accessible friendly for all users and highlight areas where ramps and elevators are located.',

  // Health Care
  'event-venues-title': 'EVENT VENUES',
  'event-venues-detail': 'Event maps and wayfinding <br/> for trade shows, conventions and festivals.',
  'event-venues-section-1-title': 'Improve the event experience <br/>with digital maps',
  'event-venues-section-1-detail': `
    Nowadays an event often looks like this: unclear directions given by a friend for the meetup location at a festival, hard time finding your way around the never-ending rows of exhibitions, and last-minute space changes don’t make it easier. Navigating around an event can be a frustrating experience for both attendees and organizers.
    <br/><br/>
    Visitors must be able to quickly find the smartest route based on their interest to make the most out of the event and contractors need to be able to locate booths in record time.
    <br/><br/>
    Mapwize, with its wayfinding capability makes it easy for people to find what they're looking for, ranging from booths to the best coffee place or even their exact seat location in a stadium.
  `,
  'event-venues-section-2-title': 'Benefits of exhibition, stadium <br/>and festival maps',
  'event-venues-section-2-detail': 'A seamless and easy-to-update outdoor/indoor mapping system is an added value for a mobile application in a crowded conference or festival venue. Digital maps with wayfinding solutions maximize the experience of your visitors with a search and direction engine.',
  'event-venues-section-2-list-item-1': 'Provide a stress-free visit experience for everyones',
  'event-venues-section-2-list-item-2': 'Increase exhibitor visibility at all zoom levels',
  'event-venues-section-2-list-item-3': 'Boost event branding and increase revenue',
  'event-venues-section-2-list-item-4': 'Go paper-free and remove printed maps',
  'event-venues-section-3-title': 'Create beautiful event maps',
  'event-venues-section-3-item-1-title': 'Wayfinding',
  'event-venues-section-3-item-1-detail': 'Enable visitors to navigate from the front door to their favorite stores. Display stores by categories, locate a specific store or a restaurant inside your shopping center.',
  'event-venues-section-3-item-2-title': 'Accessibility',
  'event-venues-section-3-item-2-detail': 'Make your hospital accessible friendly for all users and highlight areas where ramps and elevators are located.',
  'event-venues-section-3-item-3-title': 'Interactive Kiosk Maps',
  'event-venues-section-3-item-3-detail': 'Integrate your digital map into information kiosks, display the “you are here” on the map and let visitors follow the right directions on their smartphone.',
  'event-venues-section-3-item-4-title': 'Custom Map',
  'event-venues-section-3-item-4-detail': 'Create multiple personalized maps that fulfill specific needs such as visitor maps, technical maps for contractors and maps for the security department.',
  'event-venues-section-3-item-5-title': 'Live Screen Display',
  'event-venues-section-3-item-5-detail': 'Display live data on public screens such as seat availability in conference rooms and waiting time at the food court.',
  'event-venues-section-3-item-6-title': 'Extra Visibility',
  'event-venues-section-3-item-6-detail': 'Increase sponsorship opportunities for exhibitors with a logo on their map location. Selected exhibitors can be highlighted at all map zoom levels with logos providing additional value for sponsors.',

  // transportation
  'transportation-title': 'TRANSPORTATION',
  'transportation-detail': 'Indoor maps and wayfinding <br/> for airports and train stations',
  'transportation-section-1-title': 'Improve the traveler experience <br/>with interactive maps',
  'transportation-section-1-detail': `
    In the complex structure of an airport or railway station, it is a challenge for travelers to find their way around.
    <br/><br/>
    How do I reach gate 23? What is the fastest way to get to my check-in counter? Where can I found a duty-free shop? These are common questions passengers ask themselves during their travel experience. Long waiting lines at security or a last-minute gate change can make an otherwise well-planned trip stressful and hectic.
    <br/><br/>
    Mapwize’s mapping solution helps passengers plan their business trips or family vacations ahead. The interactive map displays all important points-of-interest, such as ATMs, lounges and duty-frees. In addition, the direction engine can help passengers easily get to their train platform or airport boarding gate, reducing travel stress in the process.
  `,
  'transportation-section-2-title': 'Benefits of digital maps for airports <br/>and railway stations',
  'transportation-section-2-detail': 'Digital maps with a wayfinding solution is the first step to enhance the passenger experience inside airports or stations. A seamless and easy-to-update outdoor/indoor mapping system is a clear added value for an amazing customized passenger experience and for better store visibility.',
  'transportation-section-2-list-item-1': 'Reduce passenger stress and help them navigate within the premises',
  'transportation-section-2-list-item-2': 'Increase store, hotel and restaurant visibility at all zoom levels',
  'transportation-section-2-list-item-3': 'Improve employee satisfaction with no more customer directions questions',
  'transportation-section-3-title': 'Build amazing digital transportation maps',
  'transportation-section-3-item-1-title': 'Wayfinding',
  'transportation-section-3-item-1-detail': 'Enable visitors to navigate from the front door to their favorite stores. Display stores by categories, locate a specific store or a restaurant inside your shopping center.',
  'transportation-section-3-item-2-title': 'Accessibility',
  'transportation-section-3-item-2-detail': 'Make your hospital accessible friendly for all users and highlight areas where ramps and elevators are located.',
  'transportation-section-3-item-3-title': 'Interactive Kiosk Maps',
  'transportation-section-3-item-3-detail': 'Integrate your digital map into information kiosks, display the “you are here” on the map and let visitors follow the right directions on their smartphone.',
  'transportation-section-3-item-4-title': 'Personalized Maps',
  'transportation-section-3-item-4-detail': 'Create multiple map views of your shopping mall and control access based on user profiles such as shoppers, maintenance teams and security agents.',
  'transportation-section-3-item-5-title': 'Multiple Devices',
  'transportation-section-3-item-5-detail': 'Enable visitors to navigate from the front door to their favorite stores. Display stores by categories, locate a specific store or a restaurant inside your shopping center.',
  'transportation-section-3-item-6-title': 'Indoor Navigation',
  'transportation-section-3-item-6-detail': 'Integrate your digital map into information kiosks, display the “you are here” on the map and let visitors follow the right directions on their smartphone.',

  // hospitality
  'hospitality-title': 'HOSPITALITY',
  'hospitality-detail': 'Maps and wayfinding solution <br/>for hotels, cruise lines and theme parks.',
  'hospitality-section-1-title': 'Improve guest experience with interactive maps',
  'hospitality-section-1-detail': `
    Competition in the tourism industry is fierce, that’s why differentiation is the key to the performance of organizations. Technology and wayfinding can contribute to succeed in the long term.
    <br/><br/>
    Hotel Resorts, amusement parks and large cruise ships offer many amenities that create navigational challenges for guests. How do I get from my room to the restaurant? Where is the fitness studio? These are common questions for visitors looking to make the most out of their stay.
    <br/><br/>
    Mapwize's digital map solution is a fundamental element to ensure the best guest experience possible. That way, prior to their stay, guests can view rooms on the map and select the nearest one to the spa for instance. And during their stay, they can benefit from the intuitive search engine and wayfinding system to locate any point-of-interest available.
  `,
  'hospitality-section-2-title': 'Benefits of indoor mapping for <br/>leisure & tourism industries',
  'hospitality-section-2-detail': 'A seamless and easy-to-update outdoor/indoor mapping system is an added value for hotels or cruise lines hospitality applications. Digital maps with a search and direction engine help hospitality professionals deliver personalized guest experiences that increase revenue.',
  'hospitality-section-2-list-item-1': 'mprove the hospitality experience with more guest autonomy and fewer staff interruptions',
  'hospitality-section-2-list-item-2': 'Increase revenue thanks to the “pick your room” service',
  'hospitality-section-2-list-item-3': 'Optimize operational processes: maintenance, space management and housekeeping',
  'hospitality-section-3-title': 'Build amazing digital transportation maps',
  'hospitality-section-3-item-1-title': 'Wayfinding',
  'hospitality-section-3-item-1-detail': 'Enable visitors to navigate from the front door to their favorite stores. Display stores by categories, locate a specific store or a restaurant inside your shopping center.',
  'hospitality-section-3-item-2-title': 'Accessibility',
  'hospitality-section-3-item-2-detail': 'Make your hospital accessible friendly for all users and highlight areas where ramps and elevators are located.',
  'hospitality-section-3-item-3-title': 'Interactive Kiosk Maps',
  'hospitality-section-3-item-3-detail': 'Integrate your digital map into information kiosks, display the “you are here” on the map and let visitors follow the right directions on their smartphone.',
  'hospitality-section-3-item-4-title': 'Personalized Maps',
  'hospitality-section-3-item-4-detail': 'Create multiple map views of your shopping mall and control access based on user profiles such as shoppers, maintenance teams and security agents.',
  'hospitality-section-3-item-5-title': 'Multiple Devices',
  'hospitality-section-3-item-5-detail': 'Enable visitors to navigate from the front door to their favorite stores. Display stores by categories, locate a specific store or a restaurant inside your shopping center.',
  'hospitality-section-3-item-6-title': 'Indoor Navigation',
  'hospitality-section-3-item-6-detail': 'Integrate your digital map into information kiosks, display the “you are here” on the map and let visitors follow the right directions on their smartphone.',

  // Smart Venues
  'smart-venues-head-h1': 'Smart Venues',
  'smart-venues-head-small': 'Indoor Mapping platform for the creation of new digital services \n' +
    'inside buildings and events. Our maps are easy to build \n' +
    'and even easier to integrate in your Wayfinding, Workspace Management, \n' +
    'Maintenance or Security applications.',
  'smart-venues-section-1-title': '· Smart Retails',
  'smart-venues-section-2-title': '· No positioning information for a venue',
  'smart-venues-section-3-title': '· 健康运动计步器',
  'smart-venues-section-4-title': '· 乐步',
  'smart-venues-section-5-title': '· O2O Signage',
  'smart-venues-section-1-title-1': 'Proof of Geo',
  'smart-venues-section-1-title-2': 'Applications Analyze',
  'smart-venues-section-1-item-1-text': 'Offline Navigation',
  'smart-venues-section-1-item-2-text': 'Behavioral Analytics',
  'smart-venues-section-1-item-3-text': 'Insight',
  'smart-venues-section-1-item-4-text': 'Smart Retail',
  'smart-venues-section-1-arrow-1-text': 'Uploadtion',
  'smart-venues-section-1-arrow-2-text': 'Amalyze',
  'smart-venues-section-1-arrow-3-text': 'Improve',
  'smart-venues-section-2-content': `Marketing?<br/>
    ．Cannot promote at the right time and right place
    <br/><br/>
    Data Analytics?<br/>
    ．Human Flow<br/>
    ．Heatmap
    <br/><br/>
    Services?<br/>
    ．When a visitor arrive/leave?<br/>
    ．Cannot do safety and mgt<br/>
       compliance`,
  'smart-venues-section-3-item-1-title': '精准计步',
  'smart-venues-section-3-item-1-content': '自动精准记录每日步数，简单易用',
  'smart-venues-section-3-item-2-title': '个性化目标',
  'smart-venues-section-3-item-2-content': '个性化设置每日目标',
  'smart-venues-section-3-item-3-title': '天气预报',
  'smart-venues-section-3-item-3-content': '预知天气，前提规划出行计划',
  'smart-venues-section-3-item-4-title': '健康音乐',
  'smart-venues-section-3-item-4-content': '美妙音乐，让您更投入学习，更容易入眠',
  'smart-venues-section-3-item-5-title': '热门资讯',
  'smart-venues-section-3-item-5-content': '实时掌握热点，快人一步掌握先机',
  'smart-venues-section-3-item-6-title': '短视频',
  'smart-venues-section-3-item-6-content': '观看娱乐小视频，放松心情',
  'smart-venues-section-4-item-1-title': '精准计步',
  'smart-venues-section-4-item-1-content': '自动精准记录每日步数，简单易用',
  'smart-venues-section-4-item-2-title': '统计分析',
  'smart-venues-section-4-item-2-content': '统计每日步数，曲线展示历史记录',
  'smart-venues-section-4-item-3-title': '个性化目标',
  'smart-venues-section-4-item-3-content': '个性化设置每日目标',
  'smart-venues-section-4-item-4-title': '走路线',
  'smart-venues-section-4-item-4-content': '畅玩各种景点路线',
  'smart-venues-section-4-item-5-title': '运动排行榜',
  'smart-venues-section-4-item-5-content': '精准统计用户运动排名',
  'smart-venues-section-4-item-6-title': '加油点赞',
  'smart-venues-section-4-item-6-content': '加油点赞助力，让运动更有趣',
  'smart-venues-section-5-item-1-title': 'Data Collection',
  'smart-venues-section-5-item-1-content': 'Able to collect Data Set from any Data Source',
  'smart-venues-section-5-item-2-title': 'Smart Core Engine',
  'smart-venues-section-5-item-2-content': '(Proprietary Technologies) Hybrid platforms to combine applications in Window, Webpages and APP',
  'smart-venues-section-5-item-3-title': 'Customized notification message',
  'smart-venues-section-5-item-3-content': 'Dynamic changes of AR pop up message with personalized content',
  'smart-venues-section-5-item-4-title': 'Real time integrated Information',
  'smart-venues-section-5-item-4-content': 'Able to integrate current public info, such as weather and transportation and push.',
  'smart-venues-section-5-item-5-title': 'O2O Experience',
  'smart-venues-section-5-item-5-content': 'Connecting online and offline platforms via APIs, APP integration and QR Code',
  'smart-venues-section-5-item-6-title': 'Secured real time monitor system ',
  'smart-venues-section-5-item-6-content': 'AR navigations based on existing ANY WiFi solutions without image recognition ',

  // Smart Construction
  'smart-construction-head-h1': 'Smart Construction',
  'smart-construction-head-small': 'Indoor Mapping platform for the creation of new digital services \n' +
    'inside buildings and events. Our maps are easy to build \n' +
    'and even easier to integrate in your Wayfinding, Workspace Management, \n' +
    'Maintenance or Security applications.',
  'smart-construction-section-1-title': '· Digitalized and Remote-Control Management',
  'smart-construction-section-1-content': `
    Provide a AI platform using CMS and integration with the Location Tracking APPs
    <br /><br />
    Alert online and offline when workers enter danger zones
  `,
  'smart-construction-section-2-title': '· Dangerous / Non-Permitted Zone Alert',
  'smart-construction-section-2-content': `
    User knows what to do for the upcoming period
    <br /><br />
    Date and Location Filters
  `,
  'smart-construction-section-3-title': '· BLE solutions',
  'smart-construction-section-3-content': `
    Revolutionary Application in Construction in Greater Bay Area
    <br /><br />
    The 1st Full-scale Safety Compliance APP for the Construction Industry
  `,
  'smart-construction-section-3-small': 'A worker’s location will be displayed and able to be shared to management.',
  'smart-construction-section-4-title': '· The positioning raw data',
  'smart-construction-section-5-title': '· Provide analytics visualization reports in CMS.',
  'smart-construction-section-6-title': '· Number of visit of the last few mth',
  'smart-construction-section-7-title': '· Filter absent/present by name/group',
  'smart-construction-section-8-title': '· Export Data Into different Formats',
  'smart-construction-section-9-title': '· Dynamic Geofences',
  'smart-construction-section-10-title': '· Easy to Filter any Item and Records',

  // Our Client
  'our-client-head-h1': 'OUR CLIENT',
  'our-client-head-small': `
    Indoor Mapping platform for the creation of new digital services
    inside buildings and events. Our maps are easy to build
    and even easier to integrate in your Wayfinding, Workspace Management,
    Maintenance or Security applications.
  `,
  'our-client-section-1-title': 'User Feedback',
  'our-client-section-2-title': 'User Cases',

  // Who are we
  'who-are-we-head-h1': 'Who are we',
  'who-are-we-head-small': `
    Indoor Mapping platform for the creation of new digital services
    inside buildings and events. Our maps are easy to build
    and even easier to integrate in your Wayfinding, Workspace Management,
    Maintenance or Security applications.
  `,

  // our team
  'our-team-head-h1': 'OUR TEAM',
  'our-team-head-small': `
    We are solely focused on providing the most complete mapping tools and indoor user experience.
  `,
  'our-team-title': 'Our awesome team',
  'section-title-study': '健康运动生活',
  'section-sub-title-study': '每天运动，健康生活每一天，习惯养成',
  'section-sub-title-study—idiom': '人人走路计步器（人人计步器）',
  'download-study-idiom-title': '扫描二维码下载',
  'download-study-idiom-des': '人人走路计步器（人人计步器）Android版',
  'smart-venues-section-idiom-title': '人人走路计步器（人人计步器）',
  'idiom-instro-title-1': '海量成语',
  'idiom-instro-des-1': '海里成语，让您学富五车',
  'idiom-instro-title-2': '详细解析',
  'idiom-instro-des-2': '让您更容易记住该成语',
  'idiom-instro-title-3': '温馨提示',
  'idiom-instro-des-3': '让您闯关学习没压力',
  'smart-venues-section-cooler-title': '手机降温宝',
  'cooler-instro-title-1': 'CPU',
  'cooler-instro-des-1': '检测CPU温度，CPU使用率',
  'cooler-instro-title-2': 'RAM',
  'cooler-instro-des-2': '检测RAM使用率',
  'cooler-instro-title-3': '清理',
  'cooler-instro-des-3': '清理耗电进程',
  'section-title-tools': '学习闯关',
  'section-sub-title-tools': '每天学习挑战智力',
  'section-sub-title-tools—cooler': '人人答题',
  'download-study-cooler-title': '扫描二维码下载',
  'download-study-cooler-des': '人人答题Android版'
}
